import React, { useEffect, useState } from 'react';
import { Select, Form } from 'antd';
import { partMarkupApi } from '../../services/api';
import type { PartMarkupPreset } from '../../types';

export function MarkupPicker({
  valueId,
  onPick,
  disabled,
  size = 'small',
  style,
  customLabel,
}: {
  valueId?: number | null;
  onPick: (preset: { id: number; markup_percentage: number }) => void;
  disabled?: boolean;
  size?: 'small' | 'middle' | 'large';
  style?: React.CSSProperties;
  customLabel?: boolean;
}) {
  const [presets, setPresets] = useState<PartMarkupPreset[]>([]);
  useEffect(() => {
    partMarkupApi.getAll().then(r => setPresets(r.data)).catch(() => setPresets([]));
  }, []);
  return (
    <Select
      size={size}
      style={{ minWidth: 130, ...style }}
      disabled={disabled}
      value={valueId ?? undefined}
      placeholder={customLabel ? 'Custom' : 'Markup'}
      onChange={(id: number) => {
        const r = presets.find(x => x.id === id);
        if (r) onPick({ id: r.id, markup_percentage: r.markup_percentage });
      }}
      options={presets.map(r => ({ value: r.id, label: `${r.name} (${r.markup_percentage}%)` }))}
    />
  );
}

/**
 * Drop-in replacement for MarkupPicker inside antd Form contexts.
 * Uses Form.useWatch so the label stays live after manual price/% overrides
 * (plain getFieldValue doesn't trigger re-render — this does).
 */
export function WatchedMarkupPicker({
  form,
  onPick,
  disabled,
  size = 'small',
  style,
}: {
  form: any;
  onPick: (preset: { id: number; markup_percentage: number }) => void;
  disabled?: boolean;
  size?: 'small' | 'middle' | 'large';
  style?: React.CSSProperties;
}) {
  const presetId = Form.useWatch('markup_preset_id', form);
  const pct = Form.useWatch('markup_percentage', form);
  return (
    <MarkupPicker
      valueId={presetId}
      customLabel={presetId == null && pct != null}
      onPick={onPick}
      disabled={disabled}
      size={size}
      style={style}
    />
  );
}
